import React, { useState } from "react";

import { useForm } from "react-hook-form";

import { ReactComponent as HideTextSvg } from '../assets/hide_text.svg';
import { ReactComponent as ShowTextSvg } from '../assets/show_text.svg';

import { useNavigate } from 'react-router-dom';

import { loginUser, signInWithGoogle } from '../firebase';

export default function SignIn({toggleForm}) {

    const {
		register,
		reset,
		handleSubmit,
		formState: { errors },
	} = useForm();

    const navigate = useNavigate();

    const [isShowPassword, setShowPassword] = useState(false);
    const togglePassword = () => {
        setShowPassword(!isShowPassword);
    };

    const [auth_error, setError] = useState('');

	const handleGoogleSignIn = (event) => {
		event.preventDefault(); // Prevent default form submission

		signInWithGoogle()
			.then((userCredential) => {
				// User signed in
				navigate('/');
			})
			.catch((error) => {
				console.error("Google Sign-In Error: ", error);
				// Handle errors here, such as displaying a notification
			});
	};

    const SubmitSignIn = async (data) => {

        loginUser(data.email, data.password)
            .then((userCredential) => {
                navigate('/');
            })
            .catch((error) => {
				console.error("Firebase Auth Error: ", error);
                const errorCode = error.code;
				
                switch(errorCode){
                    case 'auth/wrong-password':
                        setError('Wrong password'); break;
                    case 'auth/user-not-found':
                        setError('User not found');break;
                }
            });
    };


    return (


			<form className="form-auth">
				<a href="/" className="logo"> </a>
				<label>
					<input
						{...register("email", {
							required: "Please enter your email address",
							pattern: {
								value:
									/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
								message: "Invalid email address",
							},
						})}
						type="text"
						placeholder="Email"
					/>
					<div className="error">{errors.email?.message}</div>
				</label>
				<label className="password">

					<input
					{...register("password", {
						required: "Please enter your password",
						pattern: {
							value:
								/^[a-zA-Z0-9!@#$%^&*]{6,16}$/,
							message: "Invalid password",
						},
					})}
					placeholder="Password"
					type={isShowPassword ? 'text' : 'password'}
					/>
					<div className="error">{errors.password?.message}</div>

					<HideTextSvg
						className={isShowPassword ? null : 'hide'}
						onClick={togglePassword}
					/>
					<ShowTextSvg
						className={isShowPassword ? 'hide': null}
						onClick={togglePassword}
					/>
				</label>
				

				<label className="submit">
					<button className="lagoon-btn" type="submit"
						onClick={handleSubmit((data) => {
							SubmitSignIn(data);
							// reset();
						})}
					>Log in</button>
					<div className="error">{auth_error}</div>


				<button className="login-with-google-btn" onClick={handleGoogleSignIn}>Sign in with Google</button>

					<div className="signup-link" onClick={toggleForm}>
						<span>Sign up</span>
					</div>

				</label>


			</form>

	);

}
